import { render, staticRenderFns } from "./VentanaTerminal.vue?vue&type=template&id=b7ad1b4c&scoped=true&"
import script from "./VentanaTerminal.vue?vue&type=script&lang=js&"
export * from "./VentanaTerminal.vue?vue&type=script&lang=js&"
import style0 from "./VentanaTerminal.vue?vue&type=style&index=0&id=b7ad1b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ad1b4c",
  null
  
)

export default component.exports